import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';
import { useCommon } from 'src/domains/common/Common';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';
import {
    getPlace,
    getRunner,
    getSP,
    getTcFc,
    getWinner,
} from 'src/domains/sportsbook/webview/components/raceSummary/utils/Utils';
import { RaceSummaryRowGreyhoundRacing } from 'src/domains/sportsbook/webview/components/raceSummary/raceSummaryRowSport/greyhoundRacing/RaceSummaryRowGreyhoundRacing';
import { RaceSummaryCastRowGreyhoundRacing } from 'src/domains/sportsbook/webview/components/raceSummary/raceSummaryRowSport/greyhoundRacing/RaceSummaryCastRowGreyhoundRacing';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface GreyhoundRacingRowPropsType {
    selectionId: SelectionId;
    type?: string;
    displayTrainer?: boolean;
    isRaceInProgress?: boolean;
    isPriceHistoryHidden: boolean;
}

export const GreyhoundRacingRow = observer('GreyhoundRacingRow', (props: GreyhoundRacingRowPropsType) => {
    const { selectionId, type, displayTrainer, isRaceInProgress, isPriceHistoryHidden } = props;
    const common = useCommon();
    const breakpointsState = BreakpointsState.get(common);
    const configState = ConfigComponents.get(common).config;
    const { sportsbookVariant } = configState.componentVariants;

    const selectionModel = selectionId.getModel();
    if (selectionModel === null) {
        return null;
    }

    const marketModel = selectionModel.getMarket();
    if (marketModel === null) {
        return null;
    }

    const eventModel = marketModel.getEvent();
    if (eventModel === null) {
        return null;
    }

    const isNonRunner = selectionModel.resultType === 'void';
    const isUnnamedFavourite = selectionModel.templateId === 'unnamed-favourite';

    // The SP for unnamed favourite should always be visible
    const spSelection =
        isUnnamedFavourite || breakpointsState.tablet.isBiggerOrEq === true
            ? getSP(selectionModel, sportsbookVariant)
            : null;

    if (type === undefined) {
        return (
            <RaceSummaryRowGreyhoundRacing
                isRaceInProgress={isRaceInProgress}
                antePost={eventModel.antePost}
                isNonRunner={isNonRunner}
                isPriceHistoryHidden={isPriceHistoryHidden}
                isUnnamedFavourite={isUnnamedFavourite}
                selectionId={selectionId}
                runner={getRunner(selectionModel, isUnnamedFavourite, false, displayTrainer)}
                winner={getWinner(selectionModel, sportsbookVariant)}
                sp={spSelection}
                trapChallengeTag={marketModel.trapChallengeTag}
                dataTest='race-summary-row'
            />
        );
    }
    if (type === 'cast') {
        return (
            <RaceSummaryCastRowGreyhoundRacing
                isUnnamedFavourite={isUnnamedFavourite}
                selectionId={selectionId}
                runner={getRunner(selectionModel, isUnnamedFavourite, true)}
                place={getPlace(selectionModel)}
                isNonRunner={isNonRunner}
                {...getTcFc(selectionModel, marketModel, sportsbookVariant)}
                dataTest='race-summary-cast-row'
            />
        );
    }

    return null;
});
